module.exports = __webpack_public_path__ + "summernote.6e72b5d181d3c1793e71.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plugins/summernote/0.8.9/font/summernote.eot?e557617934c52ea068954af79ed7c221
// module id = 805
// module chunks = 2